@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.edit-button {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: @space-8;
}

.edit-icon {
  height: 12px;
  width: 12px;
  margin: @space-0 @space-8 @space-0 @space-4;
}

.actions {
  justify-content: space-between;
  padding: @space-16 0;
  border-bottom: 1px solid var(--grey-300);
  align-items: center;
}
